import v2_background from '../assets/images/v2_background.png';
import v2_background_glow_ellipse from '../assets/images/v2_background_glow_ellipse.svg';
import v2_barcode from '../assets/images/v2_barcode.png';
import v2_copy from '../assets/images/v2_copy.png';
import v2_dropdown_arraow_back from '../assets/images/v2_dropdown_arraow_back.png';
import v2_dropdown_arraow_down from '../assets/images/v2_dropdown_arraow_down.png';
import v2_game_pause from '../assets/images/v2_game_pause.png';
import v2_image_placeholder from '../assets/images/v2_image_placeholder.jpg';
import v2_rapchik_logo from '../assets/images/v2_rapchik_logo.png';
import v2_rap_fire from '../assets/images/v2_rap_fire.png';
import v2_rap_fire_dashboard_hero from '../assets/images/v2_rap_fire_dashboard_hero.gif';
import v2_rap_fire_create_room from '../assets/images/v2_rap_fire_create_room.png';
import v2_rap_fire_join_room from '../assets/images/v2_rap_fire_join_room.png';
import v2_rap_fire_question_clock from '../assets/images/v2_rap_fire_question_clock.svg';
import v2_rap_fire_question_clock_glow from '../assets/images/v2_rap_fire_question_clock_glow.png';
import v2_rap_fire_question_index_badge from '../assets/images/v2_rap_fire_question_index_badge.svg';
import v2_rapfire_qa_cross from '../assets/images/v2_rapfire_qa_cross.png';
import v2_rapfire_qa_check from '../assets/images/v2_rapfire_qa_check.png';
import v2_rapfire_qa_pending from '../assets/images/v2_rapfire_qa_pending.png';
import v2_rap_housie from '../assets/images/v2_rap_housie.png';
import v2_rap_housie_claim_bogus from '../assets/images/v2_rap_housie_claim_bogus.png';
import v2_rap_housie_claim_completed from '../assets/images/v2_rap_housie_claim_completed.png';
import v2_rap_housie_claim_winner from '../assets/images/v2_rap_housie_claim_winner.png';
import v2_rap_league from '../assets/images/v2_rap_league.png';
import v2_rap_wheel from '../assets/images/v2_rap_wheel.png';
import v2_game_card_rap_fire from '../assets/images/v2_game_card_rap_fire.png';
import v2_game_card_rap_housie from '../assets/images/v2_game_card_rap_housie.png';
import v2_game_card_rap_league from '../assets/images/v2_game_card_rap_league.png';
import v2_game_card_rap_wheel from '../assets/images/v2_game_card_rap_wheel.png';
import v2_revamped_rapfire_card_main from '../assets/images/v2_revamped_rapfire_card_main.gif';
import v2_revamped_raphousie_card_main from '../assets/images/v2_revamped_raphousie_card_main.gif';
import v2_revamped_rapwheel_card_main from '../assets/images/v2_revamped_rapwheel_card_main.gif';
import v2_game_avatar_a from '../assets/images/v2_game_avatar_a.png';
import v2_header_logo from '../assets/images/v2_header_logo.png';
import v2_header_avatar from '../assets/images/v2_header_avatar.png';
import v2_header_housie_icon from '../assets/images/v2_header_housie_icon.png';
import v2_housie_dashboard_hero from '../assets/images/v2_housie_dashboard_hero.png';
import v2_revamped_housie_hero_bg from '../assets/images/v2_revamped_housie_hero_bg.jpg';
import v2_revamped_rapfire_hero_bg from '../assets/images/v2_revamped_rapfire_hero_bg.jpg';
import v2_housie_create_room from '../assets/images/v2_housie_create_room.png';
import v2_housie_join_room from '../assets/images/v2_housie_join_room.png';
import v2_housie_back_arrow from '../assets/images/v2_housie_back_arrow.svg';
import v2_housie_collapse_chevron_up from '../assets/images/v2_housie_collapse_chevron_up.svg';
import v2_lobby_copy_icon from '../assets/images/v2_lobby_copy_icon.svg';
import v2_lobby_housie_hero from '../assets/images/v2_lobby_housie_hero.gif';
import v2_share from '../assets/images/v2_share.png';
import v2_waiting_room from '../assets/images/v2_waiting_room.png';
import v2_xp_coin from '../assets/images/v2_xp_coin.png';
import v2_leaderboard_rank_1 from '../assets/images/v2_leaderboard_rank_1.png';
import v2_leaderboard_rank_2 from '../assets/images/v2_leaderboard_rank_2.png';
import v2_leaderboard_rank_3 from '../assets/images/v2_leaderboard_rank_3.png';
import v2_leaderboard_score_ic from '../assets/images/v2_leaderboard_score_ic.png';
import v2_podium_crown from '../assets/images/v2_podium_crown.png';
import v2_podium_rank_1 from '../assets/images/v2_podium_rank_1.png';
import v2_podium_rank_2 from '../assets/images/v2_podium_rank_2.png';
import v2_podium_rank_3 from '../assets/images/v2_podium_rank_3.png';
import v2_podium_score_ic from '../assets/images/v2_podium_score_ic.png';
import v2_podium_xp_coin from '../assets/images/v2_podium_xp_coin.png';
import v2_revamped_leaderboard_firework from '../assets/images/v2_revamped_leaderboard_firework.png';
import v2_leaderboard_congrats_banner from '../assets/images/v2_leaderboard_congrats_banner.png';
import v2_leaderboard_congrats_ribbon from '../assets/images/v2_leaderboard_congrats_ribbon.png';
import v2_revamped_congratulation_ribbon from '../assets/images/v2_revamped_congratulation_ribbon.png';
import v2_leaderboard_congrats_chevron from '../assets/images/v2_leaderboard_congrats_chevron.svg';
import v2_leaderboard_rapbazaar_banner from '../assets/images/v2_leaderboard_rapbazaar_banner.png';
import v2_leaderboard_promo_star from '../assets/images/v2_leaderboard_promo_star.svg';
import v2_tournament_stepper_rapfire from '../assets/images/v2_tournament_stepper_rapfire.png';
import v2_tournament_stepper_raphousie from '../assets/images/v2_tournament_stepper_raphousie.png';
import v2_tournament_prize_trophy from '../assets/images/v2_tournament_prize_trophy.png';
import v2_tournament_prize_star from '../assets/images/v2_tournament_prize_star.png';
import v2_tournament_prize_arrow from '../assets/images/v2_tournament_prize_arrow.png';
import v2_tournament_prize_burst from '../assets/images/v2_tournament_prize_burst.svg';
import v2_tournament_prize_ticket from '../assets/images/v2_tournament_prize_ticket.svg';
import v2_tournament_prize_ribbon from '../assets/images/v2_tournament_prize_ribbon.svg';
import v2_tournament_prize_laurel_left from '../assets/images/v2_tournament_prize_laurel_left.svg';
import v2_tournament_prize_laurel_right from '../assets/images/v2_tournament_prize_laurel_right.svg';
import v2_tournament_prize_title from '../assets/images/v2_tournament_prize_title.png';
import partner_logo from '../assets/images/partner_logo.png';
import blur_background from '../assets/images/blur_background.png';
import blur_background_2 from '../assets/images/blur_background_2.png';
import rap_fire_header_div from '../assets/images/rap_fire_header_div.png';
import option_default from '../assets/images/option_default.png';
import option_correct from '../assets/images/option_correct.png';
import option_not_correct from '../assets/images/option_not_correct.png';
import rap_fire_winner_crown from '../assets/images/rap_fire_winner_crown.png';
import rap_fire_leaderboard_winner_1 from '../assets/images/rap_fire_leaderboard_winner_1.png';
import rap_fire_leaderboard_winner_2 from '../assets/images/rap_fire_leaderboard_winner_2.png';
import rap_fire_leaderboard_winner_3 from '../assets/images/rap_fire_leaderboard_winner_3.png';
import rapcoin from '../assets/images/rapcoin.png';
import please_hold_tight from '../assets/images/please_hold_tight.png';
import winner_podium_spotlight from '../assets/images/winner_podium_spotlight.png';
import v2_badge_app_store from '../assets/images/v2_badge_app_store.png';
import v2_badge_google_play from '../assets/images/v2_badge_google_play.png';

/* Rapchik_Revamped_img exports */
import v2_revamped_apple from '../assets/images/v2_revamped_apple.svg';
import v2_revamped_app_store from '../assets/images/v2_revamped_app_store.svg';
import v2_revamped_download_on_the from '../assets/images/v2_revamped_download_on_the.svg';
import v2_revamped_playstore from '../assets/images/v2_revamped_playstore.svg';
import v2_revamped_store_getiton from '../assets/images/v2_revamped_store_getiton.svg';
import v2_revamped_subtext from '../assets/images/v2_revamped_subtext.svg';
import v2_revamped_ellipse_13312 from '../assets/images/v2_revamped_ellipse_13312.svg';
import v2_revamped_path90 from '../assets/images/v2_revamped_path90.svg';
import v2_revamped_login_checkbox from '../assets/images/v2_revamped_login_checkbox.svg';
import v2_revamped_login_checkbox_checked from '../assets/images/v2_revamped_login_checkbox_checked.svg';
import v2_revamped_login_chevron from '../assets/images/v2_revamped_login_chevron.svg';
import v2_revamped_login_divider from '../assets/images/v2_revamped_login_divider.svg';
import v2_revamped_login_field_rule from '../assets/images/v2_revamped_login_field_rule.svg';
import v2_revamped_create_room_upload from '../assets/images/v2_revamped_create_room_upload.svg';
import v2_revamped_create_room_frame from '../assets/images/v2_revamped_popup_border.png';
import v2_revamped_create_room_close from '../assets/images/v2_revamped_create_room_close_x.svg';
import v2_notification_header_bar from '../assets/images/v2_notification_header_bar.png';
import v2_notification_icon_circle from '../assets/images/v2_notification_icon_circle.svg';
import v2_notification_close_x from '../assets/images/v2_notification_close_x.svg';
import v2_notification_bell_wave from '../assets/images/v2_notification_bell_wave.png';
import v2_revamped_bell_wave from '../assets/images/v2_revamped_bell_wave.gif';
import v2_revamped_cube from '../assets/images/v2_revamped_cube.png';
import v2_revamped_cube_1 from '../assets/images/v2_revamped_cube_1.png';
import v2_revamped_day_6 from '../assets/images/v2_revamped_day_6.png';
import v2_revamped_image_38 from '../assets/images/v2_revamped_image_38.png';
import v2_revamped_logo from '../assets/images/v2_revamped_logo.png';
import v2_revamped_oval from '../assets/images/v2_revamped_oval.png';
import v2_revamped_oval_1 from '../assets/images/v2_revamped_oval_1.png';
import v2_revamped_ovel from '../assets/images/v2_revamped_ovel.png';
import v2_revamped_ovel_1 from '../assets/images/v2_revamped_ovel_1.png';
import v2_revamped_rapchik_logo from '../assets/images/v2_revamped_rapchik_logo.png';
import v2_revamped_sidebar_logo from '../assets/images/v2_revamped_sidebar_logo.png';
import v2_revamped_fe2abb2d from '../assets/images/v2_revamped_fe2abb2d.png';
import v2_revamped_bg_removal from '../assets/images/v2_revamped_bg_removal.png';
import v2_revamped_day_source from '../assets/images/v2_revamped_day_source.png';
import v2_revamped_cube_source from '../assets/images/v2_revamped_cube_source.png';
import v2_revamped_image_source from '../assets/images/v2_revamped_image_source.png';
import v2_revamped_3585fe60 from '../assets/images/v2_revamped_3585fe60.png';
import v2_revamped_chatgpt_024606 from '../assets/images/v2_revamped_chatgpt_024606.png';
import v2_revamped_chatgpt_053835 from '../assets/images/v2_revamped_chatgpt_053835.png';

import v2_revamped_header_logo from '../assets/images/v2_revamped_header_logo.png'; /* logo asset refreshed */
import v2_revamped_home_logo from '../assets/images/v2_revamped_home_logo.png'; /* Figma 18384:3803 */
import v2_revamped_header_sun from '../assets/images/v2_revamped_header_sun.png';
import v2_revamped_header_bell from '../assets/images/v2_revamped_header_bell.gif';
import v2_revamped_bgm_speaker from '../assets/images/v2_revamped_bgm_speaker.png';
import v2_revamped_bgm_mute_speaker from '../assets/images/v2_revamped_bgm_mute_speaker.png';
import v2_revamped_bgm_mute_x from '../assets/images/v2_revamped_bgm_mute_x.png';

import v2_revamped_tod_day from '../assets/images/v2_revamped_tod_day.png';
import v2_revamped_tod_sunset from '../assets/images/v2_revamped_tod_sunset.png';
import v2_revamped_tod_night from '../assets/images/v2_revamped_tod_night.png';

/* Figma dashboard components */
import v2_revamped_client_logo from '../assets/images/v2_revamped_client_logo.png';
import v2_revamped_qr_code from '../assets/images/v2_revamped_qr_code.png';
import v2_revamped_sponsors_strip from '../assets/images/v2_revamped_sponsors_strip.png';
import v2_revamped_sponsor_card_1 from '../assets/images/v2_revamped_sponsor_logo_1.png';
import v2_revamped_sponsor_card_2 from '../assets/images/v2_revamped_sponsor_logo_2.png';
import v2_revamped_sponsor_card_3 from '../assets/images/v2_revamped_sponsor_logo_3.png';
import v2_revamped_sponsor_card_4 from '../assets/images/v2_revamped_sponsor_logo_4.png';
import v2_revamped_sponsor_card_5 from '../assets/images/v2_revamped_sponsor_logo_5.png';
import v2_revamped_sponsor_card_6 from '../assets/images/v2_revamped_sponsor_logo_6.png';
import v2_revamped_sponsor_shemaroo from '../assets/images/v2_revamped_sponsor_shemaroo.png';
import v2_revamped_ad_frame from '../assets/images/v2_revamped_ad_frame.png';
import v2_revamped_ad_slide_1 from '../assets/images/v2_revamped_ad_slide_1.png';
import v2_revamped_ad_slide_2 from '../assets/images/v2_revamped_ad_slide_2.png';
import v2_revamped_ad_slide_3 from '../assets/images/v2_revamped_ad_slide_3.png';
import v2_revamped_ad_slide_4 from '../assets/images/v2_revamped_ad_slide_4.png';
import v2_revamped_ad_slide_5 from '../assets/images/v2_revamped_ad_slide_5.png';
import v2_revamped_page_bg from '../assets/images/v2_revamped_page_bg.png';
import v2_revamped_lobby_qr from '../assets/images/v2_revamped_lobby_qr.png';
import v2_revamped_lobby_chevron from '../assets/images/v2_revamped_lobby_chevron.png';
import v2_revamped_lobby_copy from '../assets/images/v2_revamped_lobby_copy.svg';
import v2_revamped_lobby_back_arrow from '../assets/images/v2_revamped_lobby_back_arrow.svg';
import v2_revamped_lobby_rapchik_logo from '../assets/images/v2_revamped_lobby_rapchik_logo.png';
import v2_live_ticker_dot from '../assets/images/v2_live_ticker_dot.svg';
import v2_live_counter_inner from '../assets/images/v2_live_counter_inner.png';
import v2_room_list_ad_shemaroo from '../assets/images/v2_room_list_ad_shemaroo.jpg';
import v2_room_list_ad_rapbazaar from '../assets/images/v2_room_list_ad_rapbazaar.jpg';
import { ROOM_TYPE_GIF } from './RoomTypeImages';

/** @deprecated Prefer ROOM_TYPE_GIF / getImageForRoomType — kept for IMAGE_CONSTANTS aliases */
const ROOM_TYPE_GIF_FAMILY = ROOM_TYPE_GIF.family;
const ROOM_TYPE_GIF_KITTY = ROOM_TYPE_GIF.kitty;
const ROOM_TYPE_GIF_CORPORATE = ROOM_TYPE_GIF.corporate;

/* asset-bust */
export const IMAGE_CONSTANTS = {
    BACKGROUND_IMAGE: v2_background,
    V2_BACKGROUND: v2_background,
    V2_BACKGROUND_GLOW_ELLIPSE: v2_background_glow_ellipse,
    V2_BARCODE: v2_barcode,
    V2_COPY: v2_copy,
    V2_DROPDOWN_ARRAOW_BACK: v2_dropdown_arraow_back,
    V2_DROPDOWN_ARRAOW_DOWN: v2_dropdown_arraow_down,
    V2_GAME_PAUSE: v2_game_pause,
    V2_IMAGE_PLACEHOLDER: v2_image_placeholder,
    V2_RAPCHIK_LOGO: v2_rapchik_logo,
    V2_RAP_FIRE: v2_rap_fire,
    V2_RAP_FIRE_DASHBOARD_HERO: v2_rap_fire_dashboard_hero,
    V2_RAP_FIRE_CREATE_ROOM: v2_rap_fire_create_room,
    V2_RAP_FIRE_JOIN_ROOM: v2_rap_fire_join_room,
    V2_RAP_FIRE_FAMILY_ROOM: ROOM_TYPE_GIF_FAMILY,
    V2_RAP_FIRE_CREATE_ROOM_FAMILY: ROOM_TYPE_GIF_FAMILY,
    V2_RAP_FIRE_CREATE_ROOM_KITTY: ROOM_TYPE_GIF_KITTY,
    V2_RAP_FIRE_CREATE_ROOM_CORPORATE: ROOM_TYPE_GIF_CORPORATE,
    V2_RAP_FIRE_QUESTION_CLOCK: v2_rap_fire_question_clock,
    V2_RAP_FIRE_QUESTION_CLOCK_GLOW: v2_rap_fire_question_clock_glow,
    /** Figma 18423:5095 — Rap Fire question 1/5 circle */
    V2_RAP_FIRE_QUESTION_INDEX_BADGE: v2_rap_fire_question_index_badge,
    V2_RAPFIRE_QA_CROSS: v2_rapfire_qa_cross,
    V2_RAPFIRE_QA_CHECK: v2_rapfire_qa_check,
    V2_RAPFIRE_QA_PENDING: v2_rapfire_qa_pending,
    V2_RAP_HOUSIE: v2_rap_housie,
    V2_RAP_HOUSIE_CLAIM_BOGUS: v2_rap_housie_claim_bogus,
    V2_RAP_HOUSIE_CLAIM_COMPLETED: v2_rap_housie_claim_completed,
    V2_RAP_HOUSIE_CLAIM_WINNER: v2_rap_housie_claim_winner,
    V2_RAP_LEAGUE: v2_rap_league,
    V2_RAP_WHEEL: v2_rap_wheel,
    V2_GAME_CARD_RAP_FIRE: v2_revamped_rapfire_card_main,
    V2_GAME_CARD_RAP_FIRE_STATIC: v2_game_card_rap_fire,
    V2_GAME_CARD_RAP_HOUSIE: v2_revamped_raphousie_card_main,
    V2_GAME_CARD_RAP_HOUSIE_STATIC: v2_game_card_rap_housie,
    V2_GAME_CARD_RAP_LEAGUE: v2_game_card_rap_league,
    V2_GAME_CARD_RAP_WHEEL: v2_revamped_rapwheel_card_main,
    V2_GAME_CARD_RAP_WHEEL_STATIC: v2_game_card_rap_wheel,
    V2_GAME_AVATAR_A: v2_game_avatar_a,
    V2_HEADER_LOGO: v2_header_logo,
    V2_HEADER_AVATAR: v2_header_avatar,
    /** Figma 17742:25897 — RapHousie header icon (94×72) */
    V2_HEADER_HOUSIE_ICON: v2_header_housie_icon,
    V2_HOUSIE_DASHBOARD_HERO: v2_housie_dashboard_hero,
    V2_REVAMPED_HOUSIE_HERO_BG: v2_revamped_housie_hero_bg,
    V2_REVAMPED_RAPFIRE_HERO_BG: v2_revamped_rapfire_hero_bg,
    V2_HOUSIE_CREATE_ROOM: v2_housie_create_room,
    V2_HOUSIE_JOIN_ROOM: v2_housie_join_room,
    V2_HOUSIE_FAMILY_ROOM: ROOM_TYPE_GIF_FAMILY,
    V2_HOUSIE_BACK_ARROW: v2_housie_back_arrow,
    V2_HOUSIE_COLLAPSE_CHEVRON_UP: v2_housie_collapse_chevron_up,
    V2_ROOM_CORPORATE: ROOM_TYPE_GIF_CORPORATE,
    V2_ROOM_FAIMILY: ROOM_TYPE_GIF_FAMILY,
    V2_ROOM_KITTY: ROOM_TYPE_GIF_KITTY,
    V2_CREATE_ROOM_FAMILY: ROOM_TYPE_GIF_FAMILY,
    V2_CREATE_ROOM_KITTY: ROOM_TYPE_GIF_KITTY,
    V2_CREATE_ROOM_CORPORATE: ROOM_TYPE_GIF_CORPORATE,
    V2_REVAMPED_CREATE_ROOM_FAMILY: ROOM_TYPE_GIF_FAMILY,
    V2_REVAMPED_CREATE_ROOM_KITTY: ROOM_TYPE_GIF_KITTY,
    V2_REVAMPED_CREATE_ROOM_CORPORATE: ROOM_TYPE_GIF_CORPORATE,
    V2_REVAMPED_CREATE_ROOM_HERO_FAMILY: ROOM_TYPE_GIF_FAMILY,
    V2_REVAMPED_CREATE_ROOM_HERO_KITTY: ROOM_TYPE_GIF_KITTY,
    V2_REVAMPED_CREATE_ROOM_HERO_CORPORATE: ROOM_TYPE_GIF_CORPORATE,
    V2_LOBBY_COPY_ICON: v2_lobby_copy_icon,
    V2_LOBBY_HOUSIE_HERO: v2_lobby_housie_hero,
    V2_SHARE: v2_share,
    V2_WAITING_ROOM: v2_waiting_room,
    V2_XP_COIN: v2_xp_coin,
    V2_LEADERBOARD_RANK_1: v2_leaderboard_rank_1,
    V2_LEADERBOARD_RANK_2: v2_leaderboard_rank_2,
    V2_LEADERBOARD_RANK_3: v2_leaderboard_rank_3,
    V2_LEADERBOARD_SCORE_IC: v2_leaderboard_score_ic,
    /** Figma 18115 podium — top-3 winner assets */
    V2_PODIUM_CROWN: v2_podium_crown,
    V2_PODIUM_RANK_1: v2_podium_rank_1,
    V2_PODIUM_RANK_2: v2_podium_rank_2,
    V2_PODIUM_RANK_3: v2_podium_rank_3,
    V2_PODIUM_SCORE_IC: v2_podium_score_ic,
    V2_PODIUM_XP_COIN: v2_podium_xp_coin,
    V2_PODIUM_FIREWORK: v2_revamped_leaderboard_firework,
    V2_LEADERBOARD_CONGRATS_BANNER: v2_leaderboard_congrats_banner,
    V2_LEADERBOARD_CONGRATS_RIBBON: v2_leaderboard_congrats_ribbon,
    V2_LEADERBOARD_CONGRATS_RIBBON_STATIC: v2_revamped_congratulation_ribbon,
    V2_LEADERBOARD_CONGRATS_CHEVRON: v2_leaderboard_congrats_chevron,
    V2_LEADERBOARD_RAPBAZAAR_BANNER: v2_leaderboard_rapbazaar_banner,
    V2_LEADERBOARD_PROMO_STAR: v2_leaderboard_promo_star,
    /** Figma 20780:14715 / 20908:2520 — tournament progress stepper icons */
    V2_TOURNAMENT_STEPPER_RAPFIRE: v2_tournament_stepper_rapfire,
    V2_TOURNAMENT_STEPPER_RAPHOUSIE: v2_tournament_stepper_raphousie,
    /** Figma 20804:17761 / 20804:16394 — completed-tournament winner prizes */
    V2_TOURNAMENT_PRIZE_TROPHY: v2_tournament_prize_trophy,
    V2_TOURNAMENT_PRIZE_STAR: v2_tournament_prize_star,
    V2_TOURNAMENT_PRIZE_ARROW: v2_tournament_prize_arrow,
    V2_TOURNAMENT_PRIZE_BURST: v2_tournament_prize_burst,
    V2_TOURNAMENT_PRIZE_TICKET: v2_tournament_prize_ticket,
    V2_TOURNAMENT_PRIZE_RIBBON: v2_tournament_prize_ribbon,
    V2_TOURNAMENT_PRIZE_LAUREL_LEFT: v2_tournament_prize_laurel_left,
    V2_TOURNAMENT_PRIZE_LAUREL_RIGHT: v2_tournament_prize_laurel_right,
    V2_TOURNAMENT_PRIZE_TITLE: v2_tournament_prize_title,
    PARTNER_LOGO: partner_logo,
    BLUR_BACKGROUND: blur_background,
    BLUR_BACKGROUND_2: blur_background_2,
    RAP_FIRE_HEADER_DIV: rap_fire_header_div,
    OPTION_DEFAULT: option_default,
    OPTION_CORRECT: option_correct,
    OPTION_NOT_CORRECT: option_not_correct,
    RAP_FIRE_WINNER_CROWN: rap_fire_winner_crown,
    RAP_FIRE_LEADERBOARD_WINNER_1: rap_fire_leaderboard_winner_1,
    RAP_FIRE_LEADERBOARD_WINNER_2: rap_fire_leaderboard_winner_2,
    RAP_FIRE_LEADERBOARD_WINNER_3: rap_fire_leaderboard_winner_3,
    RAPCOIN: rapcoin,
    PLEASE_HOLD_TIGHT: please_hold_tight,
    WINNER_PODIUM_SPOTLIGHT: winner_podium_spotlight,
    V2_BADGE_APP_STORE: v2_badge_app_store,
    V2_BADGE_GOOGLE_PLAY: v2_badge_google_play,

    /* Rapchik Revamped */
    V2_REVAMPED_APPLE: v2_revamped_apple,
    V2_REVAMPED_APP_STORE: v2_revamped_app_store,
    V2_REVAMPED_DOWNLOAD_ON_THE: v2_revamped_download_on_the,
    V2_REVAMPED_PLAYSTORE: v2_revamped_playstore,
    V2_REVAMPED_STORE_GETITON: v2_revamped_store_getiton,
    V2_REVAMPED_SUBTEXT: v2_revamped_subtext,
    V2_REVAMPED_ELLIPSE_13312: v2_revamped_ellipse_13312,
    V2_REVAMPED_PATH90: v2_revamped_path90,
    V2_REVAMPED_LOGIN_CHECKBOX: v2_revamped_login_checkbox,
    V2_REVAMPED_LOGIN_CHECKBOX_CHECKED: v2_revamped_login_checkbox_checked,
    V2_REVAMPED_LOGIN_CHEVRON: v2_revamped_login_chevron,
    V2_REVAMPED_LOGIN_DIVIDER: v2_revamped_login_divider,
    V2_REVAMPED_LOGIN_FIELD_RULE: v2_revamped_login_field_rule,
    V2_REVAMPED_CREATE_ROOM_UPLOAD: v2_revamped_create_room_upload,
    V2_REVAMPED_CREATE_ROOM_FRAME: v2_revamped_create_room_frame,
    V2_REVAMPED_CREATE_ROOM_CLOSE: v2_revamped_create_room_close,
    V2_NOTIFICATION_HEADER_BAR: v2_notification_header_bar,
    V2_NOTIFICATION_ICON_CIRCLE: v2_notification_icon_circle,
    V2_NOTIFICATION_CLOSE_X: v2_notification_close_x,
    V2_NOTIFICATION_BELL_WAVE: v2_notification_bell_wave,
    V2_REVAMPED_BELL_WAVE: v2_revamped_bell_wave,
    V2_REVAMPED_CUBE: v2_revamped_cube,
    V2_REVAMPED_CUBE_1: v2_revamped_cube_1,
    V2_REVAMPED_DAY_6: v2_revamped_day_6,
    V2_REVAMPED_IMAGE_38: v2_revamped_image_38,
    V2_REVAMPED_LOGO: v2_revamped_logo,
    V2_REVAMPED_OVAL: v2_revamped_oval,
    V2_REVAMPED_OVAL_1: v2_revamped_oval_1,
    V2_REVAMPED_OVEL: v2_revamped_ovel,
    V2_REVAMPED_OVEL_1: v2_revamped_ovel_1,
    V2_REVAMPED_RAPCHIK_LOGO: v2_revamped_rapchik_logo,
    V2_REVAMPED_SIDEBAR_LOGO: v2_revamped_sidebar_logo,
    V2_REVAMPED_RAPFIRE_CARD_MAIN: v2_revamped_rapfire_card_main,
    V2_REVAMPED_RAPHOUSIE_CARD_MAIN: v2_revamped_raphousie_card_main,
    V2_REVAMPED_RAPWHEEL_CARD_MAIN: v2_revamped_rapwheel_card_main,
    V2_REVAMPED_FE2ABB2D: v2_revamped_fe2abb2d,
    V2_REVAMPED_BG_REMOVAL: v2_revamped_bg_removal,
    V2_REVAMPED_DAY_SOURCE: v2_revamped_day_source,
    V2_REVAMPED_CUBE_SOURCE: v2_revamped_cube_source,
    V2_REVAMPED_IMAGE_SOURCE: v2_revamped_image_source,
    V2_REVAMPED_3585FE60: v2_revamped_3585fe60,
    V2_REVAMPED_CHATGPT_024606: v2_revamped_chatgpt_024606,
    V2_REVAMPED_CHATGPT_053835: v2_revamped_chatgpt_053835,
    V2_REVAMPED_CLIENT_LOGO: v2_revamped_client_logo,
    V2_REVAMPED_QR_CODE: v2_revamped_qr_code,
    V2_REVAMPED_SPONSORS_STRIP: v2_revamped_sponsors_strip,
    V2_REVAMPED_SPONSOR_CARD_1: v2_revamped_sponsor_card_1,
    V2_REVAMPED_SPONSOR_CARD_2: v2_revamped_sponsor_card_2,
    V2_REVAMPED_SPONSOR_CARD_3: v2_revamped_sponsor_card_3,
    V2_REVAMPED_SPONSOR_CARD_4: v2_revamped_sponsor_card_4,
    V2_REVAMPED_SPONSOR_CARD_5: v2_revamped_sponsor_card_5,
    V2_REVAMPED_SPONSOR_CARD_6: v2_revamped_sponsor_card_6,
    V2_REVAMPED_SPONSOR_SHEMAROO: v2_revamped_sponsor_shemaroo,
    V2_REVAMPED_AD_FRAME: v2_revamped_ad_frame,
    V2_REVAMPED_AD_SLIDE_1: v2_revamped_ad_slide_1,
    V2_REVAMPED_AD_SLIDE_2: v2_revamped_ad_slide_2,
    V2_REVAMPED_AD_SLIDE_3: v2_revamped_ad_slide_3,
    V2_REVAMPED_AD_SLIDE_4: v2_revamped_ad_slide_4,
    V2_REVAMPED_AD_SLIDE_5: v2_revamped_ad_slide_5,
    V2_REVAMPED_PAGE_BG: v2_revamped_page_bg,
    V2_REVAMPED_LOBBY_QR: v2_revamped_lobby_qr,
    V2_REVAMPED_LOBBY_CHEVRON: v2_revamped_lobby_chevron,
    V2_REVAMPED_LOBBY_COPY: v2_revamped_lobby_copy,
    V2_REVAMPED_LOBBY_BACK_ARROW: v2_revamped_lobby_back_arrow,
    V2_REVAMPED_LOBBY_RAPCHIK_LOGO: v2_revamped_lobby_rapchik_logo,
    V2_LIVE_TICKER_DOT: v2_live_ticker_dot,
    V2_LIVE_COUNTER_INNER: v2_live_counter_inner,
    /** Figma 20627:2075 / 20627:2076 — room list ads (2 banners only) */
    V2_ROOM_LIST_AD_SHEMAROO: v2_room_list_ad_shemaroo,
    V2_ROOM_LIST_AD_RAPBAZAAR: v2_room_list_ad_rapbazaar,
    V2_REVAMPED_HEADER_LOGO: v2_revamped_header_logo,
    V2_REVAMPED_HOME_LOGO: v2_revamped_home_logo,
    V2_REVAMPED_HEADER_SUN: v2_revamped_header_sun,
    V2_REVAMPED_HEADER_BELL: v2_revamped_header_bell,
    /** Figma 21110:28544 — home header BGM speaker (playing) */
    V2_REVAMPED_BGM_SPEAKER: v2_revamped_bgm_speaker,
    /** Figma 21110:28535 / 21110:28536 — mute speaker + red X */
    V2_REVAMPED_BGM_MUTE_SPEAKER: v2_revamped_bgm_mute_speaker,
    V2_REVAMPED_BGM_MUTE_X: v2_revamped_bgm_mute_x,
    V2_REVAMPED_TOD_DAY: v2_revamped_tod_day,
    V2_REVAMPED_TOD_SUNSET: v2_revamped_tod_sunset,
    V2_REVAMPED_TOD_NIGHT: v2_revamped_tod_night,
    /** Default lobby waiting video — Cloudflare Stream */
    V2_WAITING_SCREEN_VIDEO:
      'https://watch.cloudflarestream.com/58b63933b59abf51b9aa21214a93dd55',
};